import * as React from 'react';
import { namespacedClassnames } from '../../common';
import { BaseAvatar } from '../base-avatar/base-avatar';
import { Icon } from '../../primitives/icon/icon';
import { GroupIconMap } from './group-icons';
import { LightningIndicator } from './lightning-indicator';
export var getGroupInitials = function (group) {
    var initials = group.name.split(' ')
        .reduce(function (result, currentWord, idx) {
        return idx >= 1 ? result : "" + result + currentWord.substring(0, 1).toUpperCase();
    }, '');
    return initials.length ? initials : 'NA';
};
export var AutoRoutingIndicator = function (props) {
    switch (props.size) {
        case 'large':
        case 'xlarge':
            return React.createElement(LightningIndicator, { size: 'large' });
        case 'small':
        case 'xsmall':
            return React.createElement(LightningIndicator, { size: 'small' });
        case 'xxsmall':
            return React.createElement(LightningIndicator, { size: 'xxsmall' });
        case 'tiny':
            return null;
        case 'normal':
        default:
            return React.createElement(LightningIndicator, { size: 'normal' });
    }
};
export var GroupAvatar = function (props) {
    var group = props.group;
    var text = getGroupInitials(group);
    var size = props.size || 'normal';
    var className = namespacedClassnames('group-avatar', size, props.className ? props.className : '');
    return (React.createElement("div", { className: className },
        React.createElement(BaseAvatar, { size: size, id: group.id, initials: text }),
        React.createElement(Icon, { icon: GroupIconMap[props.size || 'normal'] }),
        props.autoRoutingIcon && React.createElement(AutoRoutingIndicator, { size: size })));
};
//# sourceMappingURL=group-avatar.js.map